import { GLOBAL_SEARCH_GROUP_LIMIT } from "@frontend-shared/constants";
import type { IGlobalSearchGroup } from "@frontend-shared/types";
import { useCallback, useMemo } from "react";

import { useGlobalSearch } from "@/api/global-search/useGlobalSearch";

import type {
  IGlobalSearchServerGroupsResult,
  IUseGlobalSearchServerGroupsProps,
} from "../types";

const EMPTY_GROUPS: IGlobalSearchGroup[] = [];

// NOTE: NSAI-6589 — the /search/global groups, each capped like every other
// group. Types this build does not know are kept: they render generically.
export const useGlobalSearchServerGroups = ({
  debouncedQuery,
}: IUseGlobalSearchServerGroupsProps): IGlobalSearchServerGroupsResult => {
  const { data, isLoading, isError, refetch } = useGlobalSearch({
    query: debouncedQuery,
  });

  const groups = useMemo(
    () =>
      data?.groups
        .map((group) => ({
          type: group.type,
          items: group.items.slice(0, GLOBAL_SEARCH_GROUP_LIMIT),
        }))
        .filter((group) => group.items.length > 0) ?? EMPTY_GROUPS,
    [data],
  );

  const handleRetry = useCallback((): void => {
    void refetch();
  }, [refetch]);

  return { groups, isLoading, isError, onRetry: handleRetry };
};
